import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";
import { ThreeCanvas } from "@remotion/three";
import { KuroMesh } from "./KuroAndSpark3D";

export const KuroSoloShowcase: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();

  return (
    <div
      style={{
        width,
        height,
        backgroundColor: "#070B0E",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            radial-gradient(circle at 50% 50%, rgba(0, 229, 255, 0.12) 0%, transparent 60%),
            linear-gradient(to bottom, rgba(10, 20, 26, 0.7), rgba(7, 11, 14, 0.98))
          `,
        }}
      />

      <div style={{ position: "absolute", inset: 0, zIndex: 10 }}>
        {/* Zoomed in camera centered on Kuro */}
        <ThreeCanvas
          width={width}
          height={height}
          camera={{
            fov: 34,
            position: [0, 0.4, 4.4],
          }}
          shadows
        >
          <ambientLight intensity={1.1} color="#D1E8E2" />
          <directionalLight
            castShadow
            position={[3, 6, 4]}
            intensity={3.8}
            color="#FFF4E6"
            shadow-mapSize={[2048, 2048]}
          />
          <directionalLight position={[-4, 3, 3]} intensity={1.8} color="#A7F3D0" />
          <directionalLight position={[-4, 5, -4]} intensity={4.5} color="#00E5FF" />
          <directionalLight position={[4, 5, -4]} intensity={2.5} color="#80DEEA" />
          <pointLight position={[0, -0.4, 1.8]} intensity={1.5} color="#80DEEA" distance={4} />

          {/* Stage floor */}
          <group position={[0, -0.85, 0]}>
            <mesh receiveShadow position={[0, 0, 0]}>
              <cylinderGeometry args={[2.0, 2.0, 0.12, 48]} />
              <meshStandardMaterial color="#161F26" roughness={0.7} metalness={0.1} />
            </mesh>
            <mesh position={[0, 0.065, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <ringGeometry args={[0.95, 1.02, 36]} />
              <meshBasicMaterial color="#00E5FF" />
            </mesh>
          </group>

          {/* Kuro Centered, Perfectly Framed */}
          <group position={[0, -0.8, 0]} rotation={[0, 0.25, 0]} scale={[1.15, 1.15, 1.15]}>
            <KuroMesh frame={frame} fps={fps} isSpeaking={true} isExcited={frame % 90 > 45} />
          </group>
        </ThreeCanvas>
      </div>

      {/* Clean Tag */}
      <div
        style={{
          position: "absolute",
          top: 220,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 50,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0, 229, 255, 0.15)",
            border: "1px solid rgba(0, 229, 255, 0.4)",
            padding: "8px 24px",
            borderRadius: 999,
            color: "#00E5FF",
            fontSize: 16,
            fontWeight: 800,
            letterSpacing: 2,
            textTransform: "uppercase",
            boxShadow: "0 0 25px rgba(0, 229, 255, 0.3)",
          }}
        >
          🪨 KURO • MOSS-STONE GOLEM (CLOSE-UP)
        </div>
      </div>
    </div>
  );
};
